export default __webpack_public_path__ + "static/media/im-dropdown.04bd4d41.webp";